<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="AttachmentBrowser"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="attachments"
    :headerTitle="'Attachments'|pgettext('AttachmentsView')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'attachments'|pgettext('ExportFilename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <PageHelp
        path="/products/products.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "attachments",
    path: "/attachments",
    component: "AttachmentBrowser"
  }
)

@Component()
export default class AttachmentBrowser extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_attachment')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "key",
          name: this.$fn.pgettext("AttachmentsView", "Key"),
        }
          ,
        {
          field: "object_type",
          name: this.$fn.pgettext("AttachmentsView", "Object type"),
        }
          ,
        {
          field: "file_name",
          name: this.$fn.pgettext("AttachmentsView", "File name"),
        }
          ,
        {
          field: "file_type",
          name: this.$fn.pgettext("AttachmentsView", "File type"),
        }
          ,
        {
          field: "file_size",
          name: this.$fn.pgettext("AttachmentsView", "File size"),
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("AttachmentsView", "Description"),
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        {
          field: "created_by",
          name: this.$fn.pgettext("AttachmentsView", "Created by"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("AttachmentsView", "Attachments"),
        icon: this.$config.attachment.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2022_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2022, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_2024_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_2024, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2022: actions.CloseModalAction;
    evh_7315092382398562_close_2021: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_2024: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_2023: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2022 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2022_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2021 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2022,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2021],
      }
    );
    const act_2248226175642056_setData_2024 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_2024_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_2023 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_2024,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_2023],
      }
    );
    return {
      act_7315092382398562_closeModal_2022,
      evh_7315092382398562_close_2021,
      evh_7315092382398562_close,
      act_2248226175642056_setData_2024,
      evh_2248226175642056_selectedRowsChanged_2023,
      evh_2248226175642056_selectedRowsChanged,
    }
  }
}

Vue.component("AttachmentBrowser", AttachmentBrowser);

</script>